<div class="login-container">

  <div class="login-left">
    <img class="brand-logo" src="assets/pictures/gema-m.svg" alt="GEMA">
    <h1 class="brand-name">MyGemaPro</h1>
    <p class="brand-tagline">Gebäudemanagement leicht gemacht</p>
  </div>

  <div class="login-right">
    <div class="login-form-wrapper">
      <h2 class="login-title">Willkommen zurück</h2>
      <p class="login-subtitle">Melden Sie sich an, um fortzufahren</p>

      <form [formGroup]="loginForm" class="login-form" (ngSubmit)="onSubmit()">

        <div class="field-group">
          <label for="username">Benutzername</label>
          <input id="username"
                 type="text"
                 formControlName="username"
                 nbInput
                 fullWidth
                 placeholder="Benutzername eingeben"
                 fieldSize="large"
                 data-cy="username"
                 (click)="usernameChange()"
                 (keydown)="usernameChange()">
          @if (usernameError) {
            <span class="error-msg">Benutzername benötigt!</span>
          }
        </div>

        <div class="field-group">
          <label for="password">Passwort</label>
          <nb-form-field>
            <input id="password"
                   [type]="getInputType()"
                   formControlName="password"
                   nbInput
                   fullWidth
                   placeholder="Passwort eingeben"
                   fieldSize="large"
                   data-cy="password"
                   (click)="passwordChange()"
                   (keydown)="passwordChange()">
            <button nbSuffix nbButton type="button" ghost (click)="toggleShowPassword()">
              <nb-icon pack="eva" [icon]="showPassword ? 'eye-outline' : 'eye-off-2-outline'"
                       [attr.aria-label]="showPassword ? 'Passwort verbergen' : 'Passwort anzeigen'">
              </nb-icon>
            </button>
          </nb-form-field>
          @if (passwordError) {
            <span class="error-msg">Passwort wird benötigt!</span>
          }
        </div>

        <button nbButton
                fullWidth
                class="submit-btn"
                status="primary"
                type="submit"
                [disabled]="submitting()"
                size="large"
                data-cy="login-button">
          Anmelden
        </button>

      </form>
    </div>
  </div>

</div>
